import JourneyCardLayout from '@acorn-portal/shared/src/layouts/journey-card-layout';
import OptionalExtrasSection from '@acorn-portal/shared/src/components/renewal/optional-extras-section';
import { FC, useState } from 'react';
import PriceFooter from '@acorn-portal/shared/src/components/footer/PriceFooter';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { FinancePlan, FinancePlanWithDeposit } from '@acorn-portal/shared/src/services/renewalsApi';

const OptionalExtrasPage: FC = () => {
	const [loading] = useState(false);
	const renewalStore = useAppSelector((redux) => redux.renewal);
	return (
		<>
			<JourneyCardLayout pageTitle='Optional Extras' loading={loading}>
				<OptionalExtrasSection />
			</JourneyCardLayout>
			<PriceFooter
				paymentOptions={renewalStore.renewalRatingResponse!}
				value={renewalStore.paymentOptions}
				monthlyValues={{
					rates: renewalStore.paymentOptions?.deposit
						? (renewalStore.renewalRatingResponse?.financePlanWithDeposit as FinancePlanWithDeposit)
						: (renewalStore.renewalRatingResponse?.financePlanWithoutDeposit as FinancePlan),
					annualPremium: renewalStore.renewalRatingResponse?.annualPremium || 0,
					insuranceTaxPercentage: renewalStore.renewalRatingResponse?.insurancePremiumTaxPercentage || 0,
					policyAdministrationFee: renewalStore.renewalRatingResponse?.policyAdministrationFee || 0,
					depositValue: renewalStore.paymentOptions ? 'yes' : 'no',
				}}
			/>
		</>
	);
};

export default OptionalExtrasPage;
